import { render } from "./ImgCenterDialog.vue?vue&type=template&id=49825f49&scoped=true"
import script from "./ImgCenterDialog.vue?vue&type=script&lang=js"
export * from "./ImgCenterDialog.vue?vue&type=script&lang=js"

import "./ImgCenterDialog.vue?vue&type=style&index=0&id=49825f49&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49825f49"

export default script